import { arrayOf } from 'normalizr'

import { fetch, schemas } from '../utils/fetch'
import {
  ENDPOINT_FETCH_ALBUM_SHARE,
  ENDPOINT_ALBUM_SHARE,
  ENDPOINT_SHARING,
  ENDPOINT_FETCH_EXTERNAL_SHARES,
  ENDPOINT_EXTEND_EXTERNAL_SHARE
} from '../constants'

const FETCH_ALBUM_SHARE_REQUEST = 'blayzr/share/FETCH_ALBUM_REQUEST'
const FETCH_ALBUM_SHARE_SUCCESS = 'blayzr/share/FETCH_ALBUM_SUCCESS'
const FETCH_ALBUM_SHARE_FAILURE = 'blayzr/share/FETCH_ALBUM_FAILURE'

const SHARE_ALBUM = 'blayzr/share/SHARE_ALBUM'
export const UNSHARE_ALBUM = 'blayzr/share/UNSHARE_ALBUM'

const FETCH_EXTERNAL_SHARES_REQUEST = 'blayzr/share/FETCH_EXTERNAL_SHARES_REQUEST'
const FETCH_EXTERNAL_SHARES_SUCCESS = 'blayzr/share/FETCH_EXTERNAL_SHARES_SUCCESS'
const FETCH_EXTERNAL_SHARES_FAILURE = 'blayzr/share/FETCH_EXTERNAL_SHARES_FAILURE'

const DELETE_EXTERNAL_SHARE_CODE = 'blayzr/share/DELETE_EXTERNAL_SHARE_CODE'
const SET_EXTERNAL_CODE_DURATION = 'blayzr/share/SET_EXTERNAL_CODE_DURATION'

const initialState = {
  internal: {},
  external: {}
}

export default function reducer (state = initialState, action = {}) {
  const { type, payload, meta } = action
  switch (type) {
    case FETCH_ALBUM_SHARE_REQUEST:
    case FETCH_ALBUM_SHARE_SUCCESS:
    case FETCH_ALBUM_SHARE_FAILURE:
    case SHARE_ALBUM:
    case UNSHARE_ALBUM:
      return {
        ...state,
        internal: {
          ...state.internal,
          [meta.albumID]: listReducer(state.internal[meta.albumID], action)
        }
      }
    case FETCH_EXTERNAL_SHARES_REQUEST:
      return {
        ...state,
        external: {
          fetching: true,
          error: null
        }
      }
    case FETCH_EXTERNAL_SHARES_SUCCESS:
      return {
        ...state,
        external: {
          fetching: false,
          data: payload
        }
      }
    case FETCH_EXTERNAL_SHARES_FAILURE:
      return {
        ...state,
        external: {
          fetching: false,
          error: payload
        }
      }
    case DELETE_EXTERNAL_SHARE_CODE:
      return {
        ...state,
        external: {
          ...state.external,
          data: state.external.data.filter(share => share.external_id !== payload)
        }
      }
    case SET_EXTERNAL_CODE_DURATION:
      const index = state.external.data.findIndex(share => share.external_id === meta.code)
      if (index === -1) {
        return state
      }
      return {
        ...state,
        external: {
          ...state.external,
          data: [
            ...state.external.data.slice(0, index),
            {
              ...state.external.data[index],
              duration: payload
            },
            ...state.external.data.slice(index + 1)
          ]
        }
      }
    default:
      return state
  }
}

const initialListState = {
  data: null,
  fetching: false,
  error: null
}

function listReducer (state = initialListState, action = {}) {
  const { type, payload, meta } = action
  switch (type) {
    case FETCH_ALBUM_SHARE_REQUEST:
      return {
        ...state,
        fetching: true,
        error: null
      }
    case FETCH_ALBUM_SHARE_SUCCESS:
      return {
        ...state,
        fetching: false,
        data: payload.result.records
      }
    case FETCH_ALBUM_SHARE_FAILURE:
      return {
        ...state,
        fetching: false,
        error: payload.error
      }
    case SHARE_ALBUM:
      return {
        ...state,
        fetching: false,
        data: state.data.concat(meta.userID)
      }
    case UNSHARE_ALBUM:
      return {
        ...state,
        fetching: false,
        data: state.data && state.data.filter(id => id !== meta.userID)
      }
    default:
      return state
  }
}

function fetchAlbumSharedUsersRequest (albumID) {
  return {
    type: FETCH_ALBUM_SHARE_REQUEST,
    meta: { albumID }
  }
}

function fetchAlbumSharedUsersSuccess (albumID, data) {
  return {
    type: FETCH_ALBUM_SHARE_SUCCESS,
    payload: data,
    meta: { albumID }
  }
}

function fetchAlbumSharedUsersFailure (albumID, error) {
  return {
    type: FETCH_ALBUM_SHARE_FAILURE,
    payload: error,
    meta: { albumID }
  }
}

function fetchExternalSharesRequest () {
  return {
    type: FETCH_EXTERNAL_SHARES_REQUEST
  }
}

function fetchExternalSharesSuccess (data) {
  return {
    type: FETCH_EXTERNAL_SHARES_SUCCESS,
    payload: data.records
  }
}

function fetchExternalSharesFailure (error) {
  return {
    type: FETCH_EXTERNAL_SHARES_FAILURE,
    payload: error
  }
}

const schema = {
  records: arrayOf(schemas.user)
}

export function fetchAlbumSharedUsers (albumID) {
  return (dispatch, getState) => {
    const endpoint = ENDPOINT_FETCH_ALBUM_SHARE.replace(':id', albumID)
    const options = {
      token: getState().auth.token,
      schema
    }
    dispatch(fetchAlbumSharedUsersRequest(albumID))
    return fetch(endpoint, options, dispatch).then(data => {
      dispatch(fetchAlbumSharedUsersSuccess(albumID, data))
      return data.result.records
    }, e => {
      dispatch(fetchAlbumSharedUsersFailure(albumID, e))
    })
  }
}

export function shareAlbum (albumID, userID, method = 'post', action = SHARE_ALBUM) {
  return (dispatch, getState) => {
    const endpoint = ENDPOINT_ALBUM_SHARE
      .replace(':album_id', albumID)
      .replace(':user_id', userID)

    const auth = getState().auth

    dispatch({
      type: action,
      meta: {
        albumID,
        userID,
        removeFromAlbums: action === UNSHARE_ALBUM && userID === auth.user.id
      }
    })
    return fetch(endpoint, { method, token: auth.token })
  }
}

export function unshareAlbum (albumID, userID) {
  return shareAlbum(albumID, userID, 'delete', UNSHARE_ALBUM)
}

export function fetchExternalShares () {
  return (dispatch, getState) => {
    const endpoint = ENDPOINT_FETCH_EXTERNAL_SHARES
    const options = {
      token: getState().auth.token
    }
    dispatch(fetchExternalSharesRequest())
    fetch(endpoint, options, dispatch).then(data => {
      dispatch(fetchExternalSharesSuccess(data))
    }, e => {
      dispatch(fetchExternalSharesFailure(e))
    })
  }
}

export function deleteExternalShare (code) {
  return (dispatch, getState) => {
    const endpoint = ENDPOINT_SHARING.replace(':code', code)
    const options = {
      method: 'delete',
      token: getState().auth.token
    }
    fetch(endpoint, options)
    dispatch({
      type: DELETE_EXTERNAL_SHARE_CODE,
      payload: code
    })
  }
}

export function setExternalShareDuration (code, duration) {
  return (dispatch, getState) => {
    const endpoint = ENDPOINT_EXTEND_EXTERNAL_SHARE.replace(':code', code)
    const options = {
      method: 'post',
      token: getState().auth.token,
      body: { duration }
    }
    fetch(endpoint, options)
    dispatch({
      type: SET_EXTERNAL_CODE_DURATION,
      payload: duration,
      meta: { code }
    })
  }
}



// WEBPACK FOOTER //
// ./src/redux/share.js